import {baseUrl, execute} from "./ApiUtils";
import Cookies from "js-cookie";

const gameByIdUrl = baseUrl + "game/"
const cachedGameUrl = baseUrl + "cached_game/"
const timerUrl = baseUrl + "timer/"

export function getCurrentGameCached(id, successCallBack, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }

    execute(() => fetch(cachedGameUrl + id, {
        method: 'GET',
        headers: headers,
        credentials: "include"
    }), successCallBack, errorRedirect)
}

export function getTimer(id, successCallBack, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }

    execute(() => fetch(timerUrl + id, {
        method: 'GET',
        headers: headers,
        credentials: "include"
    }), successCallBack, errorRedirect)
}

export function postTimerUpdate(id, increment, action, successCallBack, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }

    execute(() => fetch(timerUrl + id, {
        method: 'POST',
        headers: headers,
        credentials: "include",
        body: JSON.stringify({
            increment: increment,
            action: action
        }),
    }), successCallBack, errorRedirect)
}

export function setUserGameViewSettings(game_id, highlight, allowView, successCallBack, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
    const payload = {}

    if (highlight === true || highlight === false) {
        payload.game_view_highlight_steps = highlight
    }

    if (allowView === true || allowView === false) {
        payload.game_view_enable_view_all_cells = allowView
    }


    execute(() => fetch(gameByIdUrl + game_id + "/settings", {
        method: 'POST',
        headers: headers,
        credentials: "include",
        body: JSON.stringify(payload)
    }), successCallBack, errorRedirect)
}

export function changeDiceType(game_id, successCallBack, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
    const payload = {}
    execute(() => fetch(gameByIdUrl + game_id + "/dice_type", {
        method: 'POST',
        headers: headers,
        credentials: "include",
        body: JSON.stringify(payload)
    }), successCallBack, errorRedirect)
}